import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'
import { listSystemInfo } from '@/api/system/systemInfoManageApi'

// 缓存系统默认小区（用于 admin 等无小区上下文的账号发布公共活动）
let _defaultCommunityId = ''

function getCachedDefaultCommunityId() {
  if (_defaultCommunityId) {
    return _defaultCommunityId
  }
  try {
    const systemInfo = JSON.parse(localStorage.getItem('java110SystemInfo'))
    if (systemInfo && systemInfo.defaultCommunityId) {
      _defaultCommunityId = systemInfo.defaultCommunityId
    }
  } catch (e) {
    // ignore
  }
  return _defaultCommunityId
}

/**
 * 解析活动操作使用的小区：
 * 1. 物业账号有真实小区，直接使用当前小区。
 * 2. admin 等运营账号无小区（communityId 为空或 -1），回退到系统默认小区，
 *    与未登录业主端首页活动来源保持一致。
 */
function resolveCommunityId() {
  const communityId = getCommunityId()
  if (communityId && communityId !== '-1') {
    return Promise.resolve(communityId)
  }
  const cachedDefaultCommunityId = getCachedDefaultCommunityId()
  if (cachedDefaultCommunityId) {
    return Promise.resolve(cachedDefaultCommunityId)
  }
  return listSystemInfo({ page: 1, row: 1 }).then(res => {
    const list = res && res.data
    if (list && list.length > 0 && list[0].defaultCommunityId) {
      _defaultCommunityId = list[0].defaultCommunityId
    }
    return _defaultCommunityId || communityId
  }).catch(() => {
    return communityId
  })
}

// 获取活动列表
export function listActivities(params) {
  return resolveCommunityId().then(communityId => new Promise((resolve, reject) => {
    request({
      url: '/activities.listActivitiess',
      method: 'get',
      params: {
        ...params,
        communityId
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res.activitiess,
        total: res.total
      })
    }).catch(error => {
      reject(error)
    })
  }))
}

// 获取活动详情
export function getActivitiesDetail(params) {
  return resolveCommunityId().then(communityId => new Promise((resolve, reject) => {
    request({
      url: '/activities.listActivitiess',
      method: 'get',
      params: {
        ...params,
        communityId
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  }))
}

// 添加活动
export function saveActivities(data) {
  return resolveCommunityId().then(communityId => new Promise((resolve, reject) => {
    request({
      url: '/activities.saveActivities',
      method: 'post',
      data: {
        ...data,
        communityId
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  }))
}

// 更新活动
export function updateActivities(data) {
  return resolveCommunityId().then(communityId => new Promise((resolve, reject) => {
    request({
      url: '/activities.updateActivities',
      method: 'post',
      data: {
        ...data,
        communityId
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  }))
}

// 删除活动
export function deleteActivities(params) {
  return resolveCommunityId().then(communityId => new Promise((resolve, reject) => {
    request({
      url: '/activities.deleteActivities',
      method: 'post',
      data: {
        ...params,
        communityId
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  }))
}

// 获取活动类型列表
export function listActivitiesType(params) {
  return resolveCommunityId().then(communityId => new Promise((resolve, reject) => {
    request({
      url: '/activitiesType/queryActivitiesType',
      method: 'get',
      params: {
        ...params,
        communityId
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res.data
      })
    }).catch(error => {
      reject(error)
    })
  }))
}

// 上传图片
export function uploadImage(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/uploadFile/uploadImage',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
